/** Settings page (console IP allowlist) and the Telegram approval cards (Settings + Security). */
export const settings = {
  title: "Settings",
  intro: "Organization-wide settings. They apply to every brand and every team member.",
  codeRequired: "Enter the 6-digit code from your authenticator app.",
  codeFailed: "That code didn't work. Wait for the next code and try again.",

  // Console IP allowlist
  ipSaved: "Console IP allowlist saved",
  ipCleared: "Console IP allowlist cleared: any network can log in",
  ipTitle: "Console IP allowlist",
  ipSub: "Only these networks can open the console. Calls from anywhere else are refused, logged, and our ops team is alerted. A person can have a personal list instead (Team → IP list).",
  noRestriction: "No restriction",
  noRestrictionBody: "Anyone with a password and 2FA can log in from any network. Add your office or VPN addresses to lock the console down.",
  yourIp: "Your current IP: <code>{ip}</code>",
  addMyIp: "Add my IP",
  allowedNetworks: "Allowed networks",
  ipHint: "One per line (IPv4/IPv6 or CIDR range). Leave empty for no restriction. A list that doesn't include your current IP is refused, so you can't lock yourself out.",
  ipNotInList: "Your current IP isn't in the list. The server refuses to save unless one of the ranges covers it.",
  lockedOutTitle: "If everyone gets locked out",
  lockedOutBody: "iCryptoNow support can unlock the console after verifying the account owner. Contact us from your registered channel.",
  saveAllowlist: "Save allowlist",
  undoChanges: "Undo changes",
  readOnly: "Your role can see this list but not change it.",

  // Telegram: link card (Security page)
  tgUserIdInvalid: "Paste the numeric Telegram user ID the bot sent you.",
  tgTitle: "Telegram approvals",
  tgSub: "Approve or reject payouts from Telegram with two taps. Requests go to linked Owners when the organization switches this on.",
  tgLinked: "Linked",
  tgWaiting: "Waiting for confirmation",
  tgUnavailable: "Telegram approvals aren't available on this server yet.",
  tgOwnersOnly: "Only owners can approve payouts in Telegram.",
  tgLinkedTo: "Linked to <b>{who}</b> <code>(ID {id})</code>.",
  tgYourAccount: "your Telegram account",
  tgLinkedOn: "You'll get approval requests for the brands you can approve.",
  tgLinkedOrgOff: "Your organization hasn't switched Telegram approvals on yet (Settings).",
  tgKeepSafe: "There's no 2FA code in Telegram, so keep that account safe: turn on Telegram's own two-step verification (Settings → Privacy and Security).",
  tgUnlinkBtn: "Unlink Telegram",
  tgGoBack: "Go back to Telegram and tap “Confirm link”.",
  tgSentTo: "The bot sent a confirmation to ID {id}. This page updates by itself.",
  tgLinkFailed: "The link didn't work",
  tgStep1: "Open <b>@{bot}</b> in Telegram and press <b>Start</b>. The bot replies with your Telegram user ID.",
  tgOpenBot: "Open bot",
  tgStep2: "Paste the ID here and confirm with your authenticator code.",
  tgStep3: "Go back to Telegram and tap <b>Confirm link</b>.",
  tgUserId: "Telegram user ID",
  tgUserIdPlaceholder: "e.g. 548120391",
  tgLink: "Link Telegram",
  tgUnlinkTitle: "Unlink Telegram?",
  tgUnlinkDesc: "You'll stop getting approval requests in Telegram. You can link again any time.",
  tgUnlink: "Unlink",
  tgUnlinked: "Telegram unlinked",

  // Telegram: organization switch (Settings page)
  tgCapInvalid: "Enter the cap as a number, e.g. 5000.",
  tgOn: "Telegram approvals are on",
  tgOff: "Telegram approvals are off",
  tgOrgTitle: "Approve payouts in Telegram",
  tgOrgSub: "Payouts waiting for approval are also sent by @{bot} to every Owner who linked Telegram (Security page).",
  tgSendRequests: "Send approval requests to linked Owners",
  on: "On",
  off: "Off",
  tgCap: "Only up to (USD)",
  tgNoLimit: "No limit",
  tgCapHint: "Larger payouts are approved in the console only.",
  tgRule1: "Only linked Owners get requests, and only for brands they can approve.",
  tgRule2: "Maker-checker and the other rules still apply: nobody approves their own payout, new members wait 24 hours, paused payouts stay paused.",
  tgRule3: "There's no 2FA code in Telegram. Each Owner should turn on Telegram's own two-step verification and keep the account secure.",
};
